import { useEffect, useState } from 'react'

/* hook to check if the device is in portrait orientation in browser */
export const useCheckOrientation = (): boolean => {
  const [isUsedInPortrait, setIsUsedInPortrait] = useState(globalThis.matchMedia('(orientation: portrait)').matches)

  useEffect(() => {
    const mql = globalThis.matchMedia('(orientation: portrait)')
    const handler = (e: MediaQueryListEvent): void => setIsUsedInPortrait(e.matches)
    mql.addEventListener('change', handler)

    return () => mql.removeEventListener('change', handler)
  }, [])

  return isUsedInPortrait
}
